import { render, staticRenderFns } from "./BibliographyRealInfo.vue?vue&type=template&id=cb62bd20&"
import script from "./BibliographyRealInfo.vue?vue&type=script&lang=ts&"
export * from "./BibliographyRealInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BibliographyRealInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VRow,VTooltip})
